export const legacyPersonalSettingsAccessTokensRoute = {
	name: 'legacy-personal-settings-access-tokens',
	path: '/plugins/servlet/oauth/users/access-tokens',
};
